import SectionHeading from './SectionHeading';
import { relatedTerms } from '@/mocks/homeData';

export default function RelatedTerms() {
  return (
    <section id="related" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <SectionHeading
            centered
            eyebrow="关联内容"
            title="搜索时常见的关联说法"
            desc="以下说法都指向同一件事——茶杯狐影视的入口与最新地址。理解它们之间的关系，有助于你更准确地找到需要的信息。"
          />

          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {relatedTerms.map((term) => (
              <span
                key={term}
                className="rounded-full border border-background-300 bg-background-100 px-4 py-2 text-xs md:text-sm text-foreground-700"
              >
                {term}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}